import { render } from "./UserTypeSelection.vue?vue&type=template&id=343ee1b1&scoped=true"
import script from "./UserTypeSelection.vue?vue&type=script&lang=js"
export * from "./UserTypeSelection.vue?vue&type=script&lang=js"

import "./UserTypeSelection.vue?vue&type=style&index=0&id=343ee1b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343ee1b1"]])

export default __exports__